<div class="input-group">
    <input type="text"
           #dp="bsDatepicker"
           class="form-control"
           bsDatepicker
           container="body"
           [placement]="$any('auto')"
           [placeholder]="placeholder"
           [disabled]="disabled"
           [(bsValue)]="dateValue"
           (onShown)="onShown.emit();"
           (onHidden)="onHidden.emit();"
           (bsValueChange)="properNotify($event)"
           [bsConfig]="{containerClass: 'ls-theme', adaptivePosition: true, allowedPositions: ['bottom', 'top', 'right', 'left']}"
    />
    <ng-container *ngIf="resettable">
        <span
                *ngIf="dateValue" (click)="dateValue = null;"
                class="cursor-pointer link-secondary input-reset input-reset-w-icon position-absolute">×</span>
    </ng-container>
    <span [ngClass]="{'pointer-events-none': disabled}" class="input-group-text cursor-pointer" (click)="dp.show()">
        <i class="fa fa-calendar"></i>
    </span>
</div>
